import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useFormik } from 'formik';
import MaskedInput from 'react-text-mask';
import { basePath } from '../index';
import axios from 'axios';
import { useEffect } from 'react';
import { getMaskForNameWithMaxLength, pinRepeatedFourTime, pinRepeatedPattern } from './UtilityComponents/UtilityFunction';
import CustomDropdown from './UtilityComponents/CustomDropdown';

/* ------------------------------------------------------------------ */
/*  Display-masking helpers (sirf UI ke liye, formik value real rehti) */
/* ------------------------------------------------------------------ */
const STAR = '*';

const maskKeepEnds = (value, start = 2, end = 2) => {
    const str = String(value ?? '');
    if (!str) return '';
    if (str.length <= start + end) {
        return str.charAt(0) + STAR.repeat(Math.max(str.length - 1, 0));
    }
    return str.slice(0, start) + STAR.repeat(str.length - start - end) + str.slice(str.length - end);
};

const maskName = (value) =>
    String(value ?? '')
        .split(' ')
        .map((word) => (word ? word.charAt(0) + STAR.repeat(word.length - 1) : ''))
        .join(' ');

const maskEmail = (value) => {
    const str = String(value ?? '');
    if (!str) return '';
    const atIndex = str.indexOf('@');
    if (atIndex < 1) return maskKeepEnds(str, 2, 2);
    const local = str.slice(0, atIndex);
    const domain = str.slice(atIndex);
    const maskedLocal =
        local.length <= 2
            ? local.charAt(0) + STAR.repeat(local.length - 1)
            : local.slice(0, 2) + STAR.repeat(local.length - 2);
    return maskedLocal + domain;
};

const maskPAN = (value) => maskKeepEnds(value, 2, 2);

const maskPin = (value) => {
    const str = String(value ?? '');
    if (!str) return '';
    return str.length <= 2 ? STAR.repeat(str.length) : STAR.repeat(str.length - 2) + str.slice(-2);
};

const maskMobile = (value) => maskKeepEnds(value, 2, 2);

const maskAddress = (value) => {
    const str = String(value ?? '');
    if (!str) return '';
    const keepStart = 3;
    const keepEnd = 3;
    return str
        .split('')
        .map((ch, i) => {
            if (ch === ' ') return ch;
            if (str.length > keepStart + keepEnd && (i < keepStart || i >= str.length - keepEnd)) return ch;
            if (str.length <= keepStart + keepEnd && i === 0) return ch;
            return STAR;
        })
        .join('');
};

const maskAll = (value) => STAR.repeat(String(value ?? '').length);

const InvestmentProposalDetails = forwardRef((props, ref) => {

    const insurerId = Number(props?.BuyData?.InsurerId);
    const isInsurerIdTata = insurerId === 156;

    // Kaunsa field abhi edit ho raha hai (us field par masking nahi hogi)
    const [editingField, setEditingField] = useState(null);

    const defaultValues = {
        InsurerId: null,
        Occupation: '',
        Education: '',
        StateName: '',
        CityName: '',
        PinCode: '',
        Name: '',
        Email: '',
        MobileNo: '',
        PAN: '',
        Address: '',
        PinOBJ: null,
        MaritalStatus: '',
        nomineeName: '',
        nomineeAge: '',
        nomineeRelation: '',
        currentLifeStage: '',
        investmentObjective: '',
        riskAppetite: '',
        insurancePortFolioAlreadyHeld: ''
    };

    const readSessionProposalReq = () => {
        const proposalReq = sessionStorage.getItem('ProposalReq');
        if (!proposalReq) {
            return null;
        }

        try {
            return JSON.parse(proposalReq);
        } catch (error) {
            console.warn('Unable to parse ProposalReq from sessionStorage', error);
            return null;
        }
    };

    const mapRequestToValues = (request = {}, currentInsurerId = null) => ({
        ...defaultValues,
        InsurerId: currentInsurerId ?? request?.InsurerId ?? null,
        Occupation: request?.Occupation ?? '',
        Education: request?.Education ?? '',
        StateName: request?.StateName ?? '',
        CityName: request?.CityName ?? '',
        PinCode: request?.PinCode ?? request?.Pincode ?? '',
        Name: request?.FullName ?? request?.Name ?? '',
        MobileNo: request?.MobileNo ?? request?.MobileNo ?? '',
        Email: request?.EmailID ?? request?.Email ?? '',
        PAN: request?.PAN ?? '',
        Address: request?.Address ?? '',
        PinOBJ: request?.PinOBJ ?? null,
        MaritalStatus: request?.MaritalStatus ?? '',
        nomineeName: request?.nomineeName ?? '',
        nomineeAge: request?.nomineeAge ?? '',
        nomineeRelation: request?.nomineeRelation ?? '',
        currentLifeStage: request?.currentLifeStage ?? request?.CurrentLifeStage ?? '',
        investmentObjective: request?.investmentObjective ?? request?.InvestmentObjective ?? '',
        riskAppetite: request?.riskAppetite ?? request?.RiskAppetite ?? '',
        insurancePortFolioAlreadyHeld:
            request?.insurancePortFolioAlreadyHeld ?? request?.InsurancePortfolioAlreadyHeld ?? ''
    });

    const mergeSessionWithQuoteReq = (sessionRequest = {}, quoteRequest = {}) => ({
        ...sessionRequest,
        ...quoteRequest,
        InsurerId: quoteRequest?.InsurerId ?? sessionRequest?.InsurerId ?? null,
        Occupation: quoteRequest?.Occupation ?? sessionRequest?.Occupation ?? '',
        Education: quoteRequest?.Education ?? sessionRequest?.Education ?? '',
        StateName: quoteRequest?.StateName ?? sessionRequest?.StateName ?? '',
        CityName: quoteRequest?.CityName ?? sessionRequest?.CityName ?? '',
        PinCode: quoteRequest?.PinCode ?? quoteRequest?.Pincode ?? sessionRequest?.PinCode ?? '',
        Name: quoteRequest?.FullName ?? quoteRequest?.Name ?? sessionRequest?.FullName ?? sessionRequest?.Name ?? '',
        MobileNo:quoteRequest?.MobileNo ?? sessionRequest?.MobileNo ?? '',
        Email: quoteRequest?.EmailID ?? quoteRequest?.Email ?? sessionRequest?.EmailID ?? sessionRequest?.Email ?? '',
        PAN: quoteRequest?.PAN ?? sessionRequest?.PAN ?? '',
        Address: quoteRequest?.Address ?? sessionRequest?.Address ?? '',
        PinOBJ: quoteRequest?.PinOBJ ?? sessionRequest?.PinOBJ ?? null,
        MaritalStatus: quoteRequest?.MaritalStatus ?? sessionRequest?.MaritalStatus ?? '',
        nomineeName: quoteRequest?.nomineeName ?? sessionRequest?.nomineeName ?? '',
        nomineeAge: quoteRequest?.nomineeAge ?? sessionRequest?.nomineeAge ?? '',
        nomineeRelation: quoteRequest?.nomineeRelation ?? sessionRequest?.nomineeRelation ?? '',
        currentLifeStage: quoteRequest?.currentLifeStage ?? quoteRequest?.CurrentLifeStage ?? sessionRequest?.currentLifeStage ?? sessionRequest?.CurrentLifeStage ?? '',
        investmentObjective: quoteRequest?.investmentObjective ?? quoteRequest?.InvestmentObjective ?? sessionRequest?.investmentObjective ?? sessionRequest?.InvestmentObjective ?? '',
        riskAppetite: quoteRequest?.riskAppetite ?? quoteRequest?.RiskAppetite ?? sessionRequest?.riskAppetite ?? sessionRequest?.RiskAppetite ?? '',
        insurancePortFolioAlreadyHeld:
            quoteRequest?.insurancePortFolioAlreadyHeld ?? quoteRequest?.InsurancePortfolioAlreadyHeld ?? sessionRequest?.insurancePortFolioAlreadyHeld ?? sessionRequest?.InsurancePortfolioAlreadyHeld ?? ''
    });

    const getInitialFormValues = React.useCallback(() => {
        const sharedProposalReq = props?.sharedProposalData?.ProposalRequestAndResponse?.[0]?.ProposalRequest;
        if (sharedProposalReq) {
            return mapRequestToValues(sharedProposalReq, props?.BuyData?.InsurerId ?? null);
        }

        const sessionProposalReq = readSessionProposalReq();
        if (sessionProposalReq && props?.QuoteReq) {
            const mergedRequest = mergeSessionWithQuoteReq(sessionProposalReq, props.QuoteReq);
            return mapRequestToValues(mergedRequest, props?.BuyData?.InsurerId ?? sessionProposalReq?.InsurerId ?? null);
        }

        if (props?.QuoteReq) {
            return mapRequestToValues(props.QuoteReq, props?.BuyData?.InsurerId ?? null);
        }

        if (sessionProposalReq) {
            return mapRequestToValues(sessionProposalReq, props?.BuyData?.InsurerId ?? sessionProposalReq?.InsurerId ?? null);
        }

        return { ...defaultValues, InsurerId: props?.BuyData?.InsurerId ?? null };
    }, [props?.sharedProposalData, props?.QuoteReq, props?.BuyData?.InsurerId]);

    const [initialValues, setInitialValues] = useState(() => getInitialFormValues());


    const validate = values => {
        const errors = {};

        if (!values.Name) {
            errors.Name = 'Please enter name';
        }
        else if (values.Name.trim().length < 2) {
            errors.Name = "Please enter valid name";
        }

        if (!values.Email) {
            errors.Email = 'Please enter email address';
        } else if (!validateEmail(values.Email)) {
            errors.Email = 'Please enter valid email';
        }

        if (!values.MobileNo) {
            errors.MobileNo = 'Please enter mobile number';
        } else if (!/^[6-9]\d{9}$/.test(values.MobileNo)) {
            errors.MobileNo = 'Please enter valid mobile number';
        }

        if (!values.PinCode) {
            errors.PinCode = 'Please enter PIN Code';
        } else if (values.PinCode.length < 6) {
            errors.PinCode = 'Please enter a valid PIN Code';
        } else if (!pinRepeatedPattern(values?.PinCode) || !values?.PinOBJ?.State_Name) {
            errors.PinCode = 'Please enter a valid PIN Code';
        }

        if (!values.PAN && !isInsurerIdTata) {
            errors.PAN = 'Please enter PAN';
        } else if (!isInsurerIdTata && values.PAN.length !== 10) {
            errors.PAN = 'Please enter valid PAN';
        }

        if (!values.Occupation) {
            errors.Occupation = 'Please select occupation';
        }
        if (!values.Address.trim()) {
            errors.Address = 'Please enter address';
        }
        else if (values.Address.trim().length < 10 || values.Address.trim().length > 150) {
            errors.Address = 'Address should be 10 to 150 characters';
        }

        if (!values.Education) {
            errors.Education = 'Please select education';
        }
        if (!values.MaritalStatus) {
            errors.MaritalStatus = 'Please select marital status';
        }
        if (!values.nomineeName && !isInsurerIdTata) {
            errors.nomineeName = 'Please enter nominee name';
        } else if (values.nomineeName.trim().length < 2 && !isInsurerIdTata) {
            errors.nomineeName = 'Please enter valid nominee name';
        }

        if (!values.nomineeAge && !isInsurerIdTata) {
            errors.nomineeAge = 'Please enter nominee age';
        } else if (!isInsurerIdTata && (values.nomineeAge < 18 || values.nomineeAge > 99)) {
            errors.nomineeAge = 'Nominee age should be 18 to 99 years';
        }

        if (!values.nomineeRelation && !isInsurerIdTata) {
            errors.nomineeRelation = 'Please select nominee relation';
        }

        if (isInsurerIdTata && !values.currentLifeStage) {
            errors.currentLifeStage = 'Please select current Life Stage';
        }
        if (isInsurerIdTata && !values.investmentObjective) {
            errors.investmentObjective = 'Please select investment objective';
        }
        if (isInsurerIdTata && !values.riskAppetite) {
            errors.riskAppetite = 'Please select risk appetite';
        }
        if (isInsurerIdTata && !values.insurancePortFolioAlreadyHeld) {
            errors.insurancePortFolioAlreadyHeld = 'Please select insurance portfolio already held';
        }

        return errors;
    };

    const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const formik = useFormik({
        initialValues,
        validate,
        enableReinitialize: true,
        validateOnMount: true,
        onSubmit: values => {
            const data = {
                Name: values.Name,
                StateName: values.PinOBJ ? values.PinOBJ.State_Name : '',
                Occupation: values.Occupation,
                Education: values.Education,
                Email: values.Email,
                PinCode: values.PinCode,
                MobileNo: values.MobileNo,
                PAN: values.PAN,
                Address: values.Address,
                MaritalStatus: values.MaritalStatus,
                nomineeName: values.nomineeName,
                nomineeAge: values.nomineeAge,
                nomineeRelation: values.nomineeRelation,
                ...(isInsurerIdTata && {
                    currentLifeStage: values.currentLifeStage,
                    investmentObjective: values.investmentObjective,
                    riskAppetite: values.riskAppetite,
                    insurancePortFolioAlreadyHeld: values.insurancePortFolioAlreadyHeld
                })
            };

            props?.submitForm(data);
        },
    });

    /* ------------------------------------------------------------------ */
    /*  Masking logic                                                      */
    /* ------------------------------------------------------------------ */

    // Field tabhi masked dikhega jab:
    //  1) us par abhi edit nahi ho raha, 2) value hai, 3) value complete/valid hai (error nahi)
    const isMasked = (field) =>
        editingField !== field &&
        !!formik.values[field] &&
        !formik.errors[field];

    const handleFieldFocus = (field) => () => setEditingField(field);

    const handleFieldBlur = (field) => () => {
        formik.setFieldTouched(field, true);
        setEditingField(null);
    };

    // Masked (read-only) input jo click/focus hote hi edit mode me chala jata hai
    const renderMaskedView = (field, maskFn, className, extraProps = {}) => (
        <input
            type="text"
            className={className}
            placeholder=" "
            value={maskFn(formik.values[field])}
            readOnly
            onFocus={handleFieldFocus(field)}
            onClick={handleFieldFocus(field)}
            {...extraProps}
        />
    );

    useEffect(() => {
        const nextValues = getInitialFormValues();
        setInitialValues(prevValues => {
            if (JSON.stringify(prevValues) === JSON.stringify(nextValues)) {
                return prevValues;
            }

            return nextValues;
        });
    }, [props?.sharedProposalData, props?.QuoteReq, props?.BuyData?.InsurerId]);

    // Save to session only when values genuinely change (hamesha real value save hoti hai)
    const prevValuesRef = useRef(formik.values);

    useEffect(() => {
        const prevValues = prevValuesRef.current;
        if (JSON.stringify(prevValues) !== JSON.stringify(formik.values)) {
            sessionStorage.setItem('ProposalReq', JSON.stringify(formik.values));
            prevValuesRef.current = formik.values;
        }
    }, [formik.values]);

    useEffect(() => {
        const pinCode = formik.values?.PinCode;
        if (pinCode?.length === 6 && pinRepeatedPattern(pinCode)) {
            (async () => {
                try {
                    const response = await axios.post(`central/centralcall/callreqwithheader`, {
                        URL: "GetCityStateFromPin",
                        req: { PinCode: pinCode, companyId: 0 }
                    });
                    if (response.data.StatusCode === 200 && response.data.Data.length > 0) {
                        formik.setFieldValue('PinOBJ', response.data.Data[0]);
                    }
                    else {
                        formik.setFieldValue('PinOBJ', {});
                        formik.setErrors({ ...formik.errors, PinCode: "Enter valid PIN code", });
                    }
                } catch (error) {
                    console.error('Error fetching city and state:', error);
                }
            })();
        } else {
            formik.setErrors({ ...formik.errors, PinCode: "Enter valid PIN code" });
        }

    }, [formik.values?.PinCode]);

    useEffect(() => {
        let isActive = true;

        formik.validateForm().then((errors) => {
            if (!isActive) {
                return;
            }

            props.setIsFormFilled(Object.keys(errors).length === 0);
        });

        return () => {
            isActive = false;
        };
    }, [formik.values, props.setIsFormFilled]);


    useImperativeHandle(ref, () => ({
        getProposalFormData: () => {
            const { values } = formik;
            return {
                Name: values.Name,
                StateName: values.PinOBJ ? values.PinOBJ.State_Name : '',
                Occupation: values.Occupation,
                Education: values.Education,
                Email: values.Email,
                PinCode: values.PinCode,
                MobileNo: values.MobileNo,
                PAN: values.PAN,
                Address: values.Address,
                MaritalStatus: values.MaritalStatus,
                nomineeName: values.nomineeName,
                nomineeAge: values.nomineeAge,
                nomineeRelation: values.nomineeRelation,
                ...(isInsurerIdTata && {
                    currentLifeStage: values.currentLifeStage,
                    investmentObjective: values.investmentObjective,
                    riskAppetite: values.riskAppetite,
                    insurancePortFolioAlreadyHeld: values.insurancePortFolioAlreadyHeld
                })

            };
        }
    }));


    return (
        <>
            <div className="ProposalBoxDetails Proposal_Newform">
                <h4>Basic Details</h4>

                <form onSubmit={formik.handleSubmit}>
                    <div className="row">

                        {/* ---------------- NAME (disabled, hamesha masked) ---------------- */}
                        <div className="col-md-6">
                            <div className="InvestmentForm">
                                <input
                                    type="text"
                                    className="PropsInvest text-capitalize"
                                    placeholder=" "
                                    value={maskName(formik.values.Name)}
                                    disabled
                                    readOnly
                                />
                                <span className="PropsName">Name</span>
                                {formik.touched.Name && formik.errors.Name ? <small className="Error-Text">{formik.errors.Name}</small> : null}
                            </div>
                        </div>



                        {/* ---------------- NAME ---------------- */}
                        {/*<div className="col-md-6">
                            <div className="InvestmentForm">
                                {isMasked('Name') ? (
                                    renderMaskedView(
                                        'Name',
                                        maskName,
                                        'PropsInvest text-capitalize',
                                        { name: 'Name' }
                                    )
                                ) : (
                                    <input
                                        type="text"
                                        className="PropsInvest text-capitalize"
                                        placeholder=" "
                                        name="Name"
                                        {...formik.getFieldProps('Name')}
                                        autoFocus={editingField === 'Name'}
                                        onFocus={handleFieldFocus('Name')}
                                        onBlur={handleFieldBlur('Name')}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            // Remove emojis
                                            const emojiRegex =
                                                /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF][\uDC00-\uDFFF]|\u200D|\u2640|\u2642|\uFE0F)/g;

                                            const cleaned = value
                                                .replace(emojiRegex, '')
                                                .replace(/\s{2,}/g, ' ');

                                            formik.setFieldValue('Name', cleaned);
                                        }}
                                        onKeyDown={(e) => {
                                            const { value, selectionStart } = e.target;

                                            // Prevent multiple spaces
                                            if (
                                                e.key === ' ' &&
                                                (selectionStart === 0 ||
                                                    value[selectionStart - 1] === ' ')
                                            ) {
                                                e.preventDefault();
                                            }

                                            // Prevent emojis
                                            const emojiRegex =
                                                /[\u{1F600}-\u{1F6FF}|\u{1F300}-\u{1F5FF}|\u{1F700}-\u{1F77F}|\u{1F900}-\u{1F9FF}]/u;

                                            if (emojiRegex.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                )}

                                <span className="PropsName">Name</span>

                                {formik.touched.Name && formik.errors.Name ? (
                                    <small className="Error-Text">
                                        {formik.errors.Name}
                                    </small>
                                ) : null}
                            </div>
                        </div>*/}
                        


                        {/* ---------------- PAN ---------------- */}
                        {!isInsurerIdTata && <div className="col-md-6">
                            <div className="InvestmentForm">
                                {isMasked('PAN') ? (
                                    renderMaskedView('PAN', maskPAN, 'PropsInvest text-uppercase', { name: 'PAN', id: 'ForUp1' })
                                ) : (
                                    <MaskedInput
                                        type="text"
                                        className="PropsInvest text-uppercase"
                                        {...formik.getFieldProps('PAN')}
                                        placeholder=""
                                        name="PAN"
                                        mask={[
                                            /[a-zA-Z/]/,
                                            /[a-zA-Z/]/,
                                            /[a-zA-Z/]/,
                                            /[pP/]/,
                                            /[a-zA-Z/]/,
                                            /[0-9/]/,
                                            /[0-9/]/,
                                            /[0-9/]/,
                                            /[0-9/]/,
                                            /[a-zA-Z/]/,
                                        ]}
                                        guide={false}
                                        showMask={false}
                                        id="ForUp1"
                                        autoFocus={editingField === 'PAN'}
                                        onFocus={handleFieldFocus('PAN')}
                                        onBlur={handleFieldBlur('PAN')}
                                    />
                                )}
                                <span className="PropsName">PAN </span>
                                {formik.touched.PAN && formik.errors.PAN ? <small className="Error-Text">{formik.errors.PAN}</small> : null}
                            </div>
                        </div>}

                        {/* ---------------- EMAIL ---------------- */}
                        <div className="col-md-6">
                            <div className="InvestmentForm">
                                {isMasked('Email') ? (
                                    renderMaskedView('Email', maskEmail, 'PropsInvest', { name: 'Email' })
                                ) : (
                                    <input
                                        type="text"
                                        className="PropsInvest"
                                        placeholder=" "
                                        name="Email"
                                        {...formik.getFieldProps('Email')}
                                        autoFocus={editingField === 'Email'}
                                        onFocus={handleFieldFocus('Email')}
                                        onBlur={handleFieldBlur('Email')}
                                        onChange={(e) => {
                                            const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\u200D|\u2640|\u2642|\uFE0F)/g;

                                            // Remove emojis from the typed/pasted string
                                            const cleaned = e.target.value.replace(emojiRegex, '');

                                            // Also remove multiple spaces if needed
                                            const cleanedFinal = cleaned.replace(/\s{2,}/g, ' ');

                                            formik.setFieldValue("Email", cleanedFinal);
                                        }}
                                        onKeyDown={(e) => {
                                            // Prevent typing multiple consecutive spaces
                                            const { value, selectionStart, } = e.target;
                                            if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                                e.preventDefault();
                                            }
                                            // Prevent emojis (basic emoji unicode block)
                                            const emojiRegex = /[\u{1F600}-\u{1F6FF}|\u{1F300}-\u{1F5FF}|\u{1F700}-\u{1F77F}|\u{1F900}-\u{1F9FF}]/u;
                                            if (emojiRegex.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                )}
                                <span className="PropsName">Email </span>
                                {formik.touched.Email && formik.errors.Email ? <small className="Error-Text">{formik.errors.Email}</small> : null}
                            </div>
                        </div>

                        {/* ---------------- PIN CODE ---------------- */}
                        <div className="col-md-6">
                            <div className="InvestmentForm ">
                                {isMasked('PinCode') ? (
                                    renderMaskedView('PinCode', maskPin, 'PropsInvest', { name: 'PinCode', id: 'ForUp1', inputMode: 'numeric' })
                                ) : (
                                    <MaskedInput
                                        type="tel"
                                        className="PropsInvest"
                                        name="PinCode"
                                        placeholder=" "
                                        {...formik.getFieldProps('PinCode')}
                                        mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                        guide={false}
                                        showMask={false}
                                        id="ForUp1"
                                        autoFocus={editingField === 'PinCode'}
                                        onFocus={handleFieldFocus('PinCode')}
                                        onBlur={handleFieldBlur('PinCode')}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                        }}
                                    />
                                )}

                                <span className="PropsName">PIN Code</span>
                                {formik.touched.PinCode && formik.errors.PinCode ? <small className="Error-Text">{formik.errors.PinCode}</small> : null}

                                {!formik.errors.PinCode && formik.values.PinOBJ && <small className="CityStateName">{formik.values.PinOBJ.CityName?.toLowerCase()}, {formik.values.PinOBJ.State_Name?.toLowerCase()}</small>}
                            </div>
                        </div>

                        {/* ---------------- MOBILE NUMBER ---------------- */}
                        <div className="col-md-6">
                            <div className="InvestmentForm">
                                {isMasked('MobileNo') ? (
                                    renderMaskedView('MobileNo', maskMobile, 'PropsInvest', { name: 'MobileNo'})
                                ) : (
                                    <MaskedInput
                                        type="tel"
                                        className="PropsInvest"
                                        name="MobileNo"
                                        placeholder=" "
                                        {...formik.getFieldProps('MobileNo')}
                                        mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                        guide={false}
                                        showMask={false}
                                        autoFocus={editingField === 'MobileNo'}
                                        onFocus={handleFieldFocus('MobileNo')}
                                        onBlur={handleFieldBlur('MobileNo')}
                                    />
                                )}
                                <span className="PropsName">Mobile Number</span>
                                {formik.touched.MobileNo && formik.errors.MobileNo ? <small className="Error-Text">{formik.errors.MobileNo}</small> : null}
                            </div>
                        </div>

                        {/* ---------------- ADDRESS ---------------- */}
                        <div className="col-md-12">
                            <div className="InvestmentForm">
                                {isMasked('Address') ? (
                                    renderMaskedView('Address', maskAddress, 'PropsInvest', { name: 'Address' })
                                ) : (
                                    <input
                                        type="text"
                                        className="PropsInvest"
                                        placeholder=" "
                                        maxLength={150}
                                        name="Address"
                                        {...formik.getFieldProps('Address')}
                                        autoFocus={editingField === 'Address'}
                                        onFocus={handleFieldFocus('Address')}
                                        onBlur={handleFieldBlur('Address')}
                                        onKeyDown={(e) => {
                                            // Prevent typing multiple consecutive spaces
                                            const { value, selectionStart } = e.target;
                                            if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                                e.preventDefault();
                                            }
                                            // Prevent emojis (basic emoji unicode block)
                                            const emojiRegex = /[\u{1F600}-\u{1F6FF}|\u{1F300}-\u{1F5FF}|\u{1F700}-\u{1F77F}|\u{1F900}-\u{1F9FF}]/u;
                                            if (emojiRegex.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const pasted = e.clipboardData.getData("text");
                                            const emojiRegex = /[\u{1F600}-\u{1F6FF}|\u{1F300}-\u{1F5FF}|\u{1F700}-\u{1F77F}|\u{1F900}-\u{1F9FF}]/u;
                                            if (emojiRegex.test(pasted)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => {
                                            // Prevent leading whitespace
                                            const value = e.target.value;
                                            if (value.startsWith(" ")) {
                                                formik.setFieldValue('Address', value.trimStart());
                                            } else {
                                                formik.setFieldValue('Address', value);
                                            }
                                        }}
                                    />
                                )}
                                <span className="PropsName">Address</span>
                                {formik.touched.Address && formik.errors.Address ? <small className="Error-Text">{formik.errors.Address}</small> : null}
                            </div>
                        </div>

                        {/* ---------------- MARITAL STATUS ---------------- */}
                        <div className="col-md-6">
                            <div className="InvestmentForm">
                                <span className="DropDownLabel">Marital Status</span>

                                <CustomDropdown
                                    options={props.MaritalList}
                                    value={formik.values.MaritalStatus}
                                    labelKey="MasterName"
                                    valueKey="Code"
                                    placeholder="Select Marital Status"
                                    onChange={(data) => formik.setFieldValue('MaritalStatus', data.Code)}
                                />

                                {formik.touched.MaritalStatus && formik.errors.MaritalStatus ? <small className="Error-Text">{formik.errors.MaritalStatus}</small> : null}
                            </div>
                        </div>

                        {/* ---------------- OCCUPATION ---------------- */}
                        <div className="col-md-6">
                            <div className="InvestmentForm">
                                <span className={`${props?.QuoteReq?.InvestmentType == "ML" ? "disabled" : ""} DropDownLabel`}>Occupation</span>
                                <CustomDropdown
                                    disabled={props?.QuoteReq?.InvestmentType == "ML"}
                                    options={props.OccupationList?.filter(oc => (formik.values.MariralStatus == 'S' || props.QuoteReq.Gender == "M" || formik.values.MaritalStatus == 1) ? oc.Code != 3 : oc)}
                                    value={formik.values.Occupation}
                                    labelKey="MasterName"
                                    valueKey="Code"
                                    placeholder="Select Occupation"
                                    onChange={(data) => formik.setFieldValue('Occupation', data.Code)}
                                />
                                {formik.touched.Occupation && formik.errors.Occupation ? <small className="Error-Text">{formik.errors.Occupation}</small> : null}
                            </div>
                        </div>

                        {/* ---------------- EDUCATION ---------------- */}
                        <div className="col-md-6">
                            <div className="InvestmentForm">
                                <label className={`${props?.QuoteReq?.InvestmentType == "ML" ? "disabled" : ""} DropDownLabel`}>Education</label>

                                <CustomDropdown
                                    disabled={props?.QuoteReq?.InvestmentType == "ML"}
                                    options={props.EducationList}
                                    value={formik.values.Education}
                                    labelKey="MasterName"
                                    valueKey="Code"
                                    placeholder="Select Education"
                                    onChange={(data) => formik.setFieldValue('Education', data.Code)}
                                />

                                {formik.touched.Education && formik.errors.Education ? <small className="Error-Text">{formik.errors.Education}</small> : null}
                            </div>
                        </div>

                        {/* ---------------- NOMINEE DETAILS ---------------- */}
                        {!isInsurerIdTata &&
                            <div className="row mt-3">
                                <h4 className="mb-1">Nominee Details</h4>

                                {/* Nominee Name */}
                                <div className="col-md-6">
                                    <div className="InvestmentForm">
                                        {isMasked('nomineeName') ? (
                                            renderMaskedView('nomineeName', maskName, 'PropsInvest', { name: 'nomineeName' })
                                        ) : (
                                            <MaskedInput
                                                mask={getMaskForNameWithMaxLength(50)}
                                                guide={false}
                                                showMask={false}
                                                onKeyDown={(e) => {
                                                    // Prevent typing multiple consecutive spaces
                                                    const { value, selectionStart } = e.target;
                                                    if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                name="nomineeName"
                                                type="text"
                                                className="PropsInvest"
                                                placeholder=" "
                                                {...formik.getFieldProps('nomineeName')}
                                                autoFocus={editingField === 'nomineeName'}
                                                onFocus={handleFieldFocus('nomineeName')}
                                                onBlur={handleFieldBlur('nomineeName')}
                                            />
                                        )}
                                        <span className="PropsName">Nominee Name</span>
                                        {formik.touched.nomineeName && formik.errors.nomineeName ? <small className="Error-Text">{formik.errors.nomineeName}</small> : null}
                                    </div>
                                </div>

                                {/* Nominee Age */}
                                <div className="col-md-6">
                                    <div className="InvestmentForm">
                                        {isMasked('nomineeAge') ? (
                                            renderMaskedView('nomineeAge', maskAll, 'PropsInvest', { name: 'nomineeAge', inputMode: 'numeric' })
                                        ) : (
                                            <MaskedInput
                                                mask={[
                                                    /[1-9]/,
                                                    /[0-9\s]/
                                                ]}
                                                guide={false}
                                                showMask={false}
                                                type="text"
                                                className="PropsInvest"
                                                placeholder=" "
                                                name="nomineeAge"
                                                {...formik.getFieldProps('nomineeAge')}
                                                autoFocus={editingField === 'nomineeAge'}
                                                onFocus={handleFieldFocus('nomineeAge')}
                                                onBlur={handleFieldBlur('nomineeAge')}
                                            />
                                        )}
                                        <span className="PropsName">Nominee Age (in years)</span>
                                        {formik.touched.nomineeAge && formik.errors.nomineeAge ? <small className="Error-Text">{formik.errors.nomineeAge}</small> : null}
                                    </div>
                                </div>

                                {/* Nominee Relation */}
                                <div className="col-md-6">
                                    <div className="InvestmentForm">
                                        <span className="DropDownLabel">Nominee Relation</span>

                                        <CustomDropdown
                                            options={props.NomineeRelation}
                                            value={formik.values.nomineeRelation}
                                            labelKey="MasterName"
                                            valueKey="Code"
                                            placeholder="Select Nominee Relation"
                                            onChange={(data) => formik.setFieldValue('nomineeRelation', data.Code)}
                                        />
                                        {formik.touched.nomineeRelation && formik.errors.nomineeRelation ? <small className="Error-Text">{formik.errors.nomineeRelation}</small> : null}
                                    </div>
                                </div>
                            </div>
                        }

                        {/* ---------------- SUITABILITY ANALYSIS (TATA) ---------------- */}
                        {isInsurerIdTata ? (<div className="row mt-3">
                            <h4 className="mb-1">Suitability Analysis</h4>

                            <div className="col-md-6">
                                <div className="InvestmentForm">
                                    <span className="DropDownLabel">Current Life Stage</span>

                                    <CustomDropdown
                                        options={props.currentLifeStageList}
                                        value={formik.values.currentLifeStage}
                                        labelKey="MasterName"
                                        valueKey="Code"
                                        placeholder="Select Current Life Stage"
                                        onChange={(data) => formik.setFieldValue('currentLifeStage', data.Code)}
                                    />
                                    {formik.touched.currentLifeStage && formik.errors.currentLifeStage ? <small className="Error-Text">{formik.errors.currentLifeStage}</small> : null}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="InvestmentForm">
                                    <span className="DropDownLabel">Investment Objective</span>

                                    <CustomDropdown
                                        options={props.investmentObjectiveList}
                                        value={formik.values.investmentObjective}
                                        labelKey="MasterName"
                                        valueKey="Code"
                                        placeholder="Select Investment Objective"
                                        onChange={(data) => formik.setFieldValue('investmentObjective', data.Code)}
                                    />
                                    {formik.touched.investmentObjective && formik.errors.investmentObjective ? <small className="Error-Text">{formik.errors.investmentObjective}</small> : null}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="InvestmentForm">
                                    <span className="DropDownLabel">Risk Appetite</span>

                                    <CustomDropdown
                                        options={props.riskAppetiteList}
                                        value={formik.values.riskAppetite}
                                        labelKey="MasterName"
                                        valueKey="Code"
                                        placeholder="Select Risk Appetite"
                                        onChange={(data) => formik.setFieldValue('riskAppetite', data.Code)}
                                    />
                                    {formik.touched.riskAppetite && formik.errors.riskAppetite ? <small className="Error-Text">{formik.errors.riskAppetite}</small> : null}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="InvestmentForm">
                                    <span className="DropDownLabel">Insurance PortFolio Already Held</span>

                                    <CustomDropdown
                                        options={props.insurancePortFolioAlreadyHeldList}
                                        value={formik.values.insurancePortFolioAlreadyHeld}
                                        labelKey="MasterName"
                                        valueKey="Code"
                                        placeholder="Select Insurance PortFolio Already Held"
                                        onChange={(data) => formik.setFieldValue('insurancePortFolioAlreadyHeld', data.Code)}
                                    />
                                    {formik.touched.insurancePortFolioAlreadyHeld && formik.errors.insurancePortFolioAlreadyHeld ? <small className="Error-Text">{formik.errors.insurancePortFolioAlreadyHeld}</small> : null}
                                </div>
                            </div>

                        </div>) : ""}

                        <div className="row">
                            <div className="col-md-12">
                                <div className="d-flex justify-content-center">
                                    <button type="submit" className="buttonLarg">
                                        {props.BtnVal}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
});

export default InvestmentProposalDetails;